import moment from 'moment-timezone';

export const handelError = (error, setFormData) => {
  const errors = error.issues;
  console.error(errors);

  errors.length > 0 &&
    errors.forEach((error) => {
      if (error.message !== "") {
        const field = error.path[0] + "Err";

        setFormData((_prevState) => ({
          ..._prevState,
          [field]: true,
          [`${field}Msg`]: error.message,
        }));
      }
    });
};

export const getDateLabel = (dateString) => {
  const date = moment.utc(dateString).local();
  const today = moment();
  const yesterday = moment().subtract(1, 'days');

  if (date.isSame(today, 'day')) {
    return 'Today';
  } else if (date.isSame(yesterday, 'day')) {
    return 'Yesterday';
  } else {
    return date.format('MM/DD/YYYY');
  }
};